import { Inline, Stack } from "PFComponents/containers";
import { Icon } from "PFComponents/icon";
import { Typography } from "PFComponents/typography";

type WarningMessageProps = {
  title: string;
  message: string;
  kind: "overbooking" | "error";
};

export const WarningMessage = ({ title, message, kind }: WarningMessageProps) => (
  <Inline gap="spacingLg" alignItems="center">
    <Icon name={kind} color={kind === "error" ? "paletteRed0" : undefined} size="xl" />
    <Stack gap={null}>
      <Typography variant="bodyBold">{title}</Typography>
      <Typography variant="bodyRegular">{message}</Typography>
    </Stack>
  </Inline>
);
